import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SrModalV2, {
  MODAL_THEME_FIXED_FOOTER_BUTTON,
} from 'client/components/SrModalV2/SrModalV2';
import {
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const initialState = {
  showMessage: false,
};

class SrPetScreeningLinkModal extends Component {
  static propTypes = {
    petScreeningLink: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  render() {
    const {
      petScreeningLink,
      showModal,
      onClose,
    } = this.props;

    if (!showModal || !petScreeningLink) {
      return null;
    }

    return (
      <SrModalV2
        theme={MODAL_THEME_FIXED_FOOTER_BUTTON}
        onClose={onClose}
        contentPadding='28px 0 120px 0'
        buttonText='Verify Pets'
        buttonTheme={SR_BUTTON_THEME_ADOBE_BLUE}
      >
        <SrBox>
          <SrBox padding='0 32px'>
            <img
              width='100%'
              height='auto'
              src='/images/pet-screening-photo.jpg'
              alt='petscreening.com'
            />
            <SrBox marginTop='48px' />
            <SrText
              font='greycliff'
              paddingBottom='15px'
              size='30'
              lineHeight='36px'
              weight='800'
              display='block'
              color='blueGreycliff'
            >
              Verify Your Pets
            </SrText>
            <SrBox marginTop='4px' />
            <SrText
              font='greycliff'
              size='16'
              lineHeight='25px'
              weight='400'
              color='grey600'
              display='block'
            >
              This property requires applicants to complete a pet screening with their application.
            </SrText>
            <SrBox marginTop='30px' />
            <SrText
              font='greycliff'
              size='16'
              lineHeight='25px'
              weight='600'
              color='grey600'
            >
              Please share the email with us once it's finished.&nbsp;
            </SrText>
            <SrText
              font='greycliff'
              size='16'
              lineHeight='25px'
              weight='400'
              color='grey600'
            >
              Pet screening is required for each applicant's pets and service animals.
              There is a $25 or $20 per pet fee depending on the payment method.
              Complete the "Assistance Animals" pet screening form for your emotional
              support or service animals (ESA).
              There is no charge for ESA screening.
              Sunroom does not make money from this fee, it all goes to the screening company.
            </SrText>
          </SrBox>
        </SrBox>
      </SrModalV2>
    );
  }
}

SrPetScreeningLinkModal.displayName = 'SrPetScreeningLinkModal';

export default SrPetScreeningLinkModal;
